module.exports = __webpack_public_path__ + "static/media/my-family-campaign-banner-mobile.8746d983.jpg";